"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContactCardDetailItem = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _react = _interopRequireDefault(require("react"));
var _useTheme = require("../../../theme/utils/useTheme");
var _typography = require("../../typography");
var _constants = require("../constants");
var _contactCardTheme = require("../contactCardTheme");
const ContactCardDetailItem = _ref => {
  let {
    children,
    ...rest
  } = _ref;
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const typeRampVariant = _contactCardTheme.contactCardTypeRampVariants.detailItem(themeMode);
  return (
    /*#__PURE__*/
    // @ts-expect-error variant type is complaining
    _react.default.createElement(ContactCardDetailItemStyled, (0, _extends2.default)({}, rest, {
      variant: typeRampVariant,
      lineClamp: 1,
      themeMode: themeMode
    }), children)
  );
};
exports.ContactCardDetailItem = ContactCardDetailItem;
const ContactCardDetailItemStyled = (0, _styled.default)(_typography.TypeRampV2)`
    display: block;
    color: ${_ref2 => {
  let {
    themeMode
  } = _ref2;
  return _contactCardTheme.contactCardTheme.colors.detailItem(themeMode);
}};
    label: ${_constants.ccdetailitemlabel};

    + [class*="${_constants.ccinfoitemlabel}"] {
        margin-top: 12px;
    }

    + [class*="${_constants.ccactionlabel}"] {
        margin-top: 8px;
    }

    & + & {
        padding-top: ${_ref3 => {
  let {
    themeMode
  } = _ref3;
  return _contactCardTheme.contactCardTheme.lineSeparation(themeMode);
}};
    }
`;
//# sourceMappingURL=ContactCardDetailItem.js.map